import React, { useContext, useEffect, useState } from "react";
import ProductCard from "../../../components/ProductCard/ProductCard";
import "./productPage.css";
import ButtonComponent from "../../../components/Button/Button";
import Constants from "../../../constants/Contents.json";
import { Card, Col, Row } from "react-bootstrap";
import Capacity from "../../../assets/capacity.svg";
import wave from "../../../assets/wave.svg";
import PlusIcon from "../../../assets/PlusIcon";
import VguardHoriz from "../../../assets/VgaurdHorizontal.svg";
import VguardVertical from "../../../assets/VgaurdVertical.svg";
import BannerShape from "../../../assets/BannerShape.svg";
import Timer from "../../../assets/timer.svg";
import HomeIcon from "../../../assets/Bhk.svg";
import Utilisation from "../../../assets/utilization.svg";
import TotalLoad from "../../../assets/totalLoad.svg";
import Devices from "../../../assets/devices.svg";
import WarningIcon from "../../../assets/warnIcon.png";
import { motion } from "framer-motion";
import { ProductPageContext } from "../ProductPageView";
import {
  cardVariants,
  fromBottom,
  fromLeft,
  fromRight,
  scaleFromRightCorner,
} from "../../../utils/AnimationStyles";
import ErrorImage from "../../../assets/error.svg";
import SuccessImage from "../../../assets/SuccessImage.svg";
import FindDealer from "../../../components/FindADealer/FindDealer";
import EnterDetailsPopup from "../../../components/EnterDetailsPopup/EnterDetailsPopup";
import SuccessPopup from "../../../components/CommonPopup/CommonPopup";
import ErrorPopup from "../../../components/CommonPopup/CommonPopup";
import Solar from "../../../assets/icons/Solar";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import Connectivity from "../../../assets/icons/Connectivity";
import constantDomain from "../../../constants/DomainConfig.json";
const ProductPage = () => {
  const {
    showModal,
    setShowModal,
    dealerData,
    handleInputChange,
    handleSearch,
    showEnquireModal,
    setShowEnquireModal,
    popupUserDetails,
    ConnectDealer,
    userDetailsToSend,
    isLoading,
    handleCloseModal,
    showDealerData,
    productData,
    topChoice,
    successPopup,
    setSuccessPopup,
    errorPopup,
    setErrorPopup,
    popupMessage,
    domain,
    capitalizeWords,
    warningMessage,
    comboShow,
  } = useContext(ProductPageContext);
  const staticContent = Constants.productPage;
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const navigate = useNavigate();
  const endPoint = domain; // com, in
  const bestCombo = comboShow;
  return (
    <div className="product-page">
      <div className="productPageContainer">
        <div>
          <div className="banner">
            <motion.div
              className="mainTextGroup"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.div
                className="mainText"
                variants={fromLeft}
                custom={0} // First element, no delay
              >
                <span>{staticContent.title} </span>
                <span style={{ color: "#FDB426" }}>{staticContent.title2}</span>
              </motion.div>

              <motion.div
                className="description"
                variants={fromLeft}
                custom={1}
              >
                {staticContent.description}
              </motion.div>

              <div className="load-data-section">
                <motion.div variants={fromBottom} custom={0}>
                  <img src={HomeIcon} />
                  <div>{productData?.propertyType}</div>
                </motion.div>
                <motion.div variants={fromBottom} custom={1}>
                  <img src={Utilisation} />
                  <div>
                    {productData?.utilization}
                    {staticContent.Utilisation}
                  </div>
                </motion.div>
                <motion.div variants={fromBottom} custom={2}>
                  <img src={Timer} />
                  <div>
                    {productData?.powerBackup} {staticContent.Hours}
                  </div>
                </motion.div>
              </div>
            </motion.div>
            <motion.div
              className="deviceImageSection"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.img
                src={BannerShape}
                alt=""
                variants={scaleFromRightCorner}
                custom={0}
              />

              <motion.div variants={fromRight} className="total-load">
                <img src={TotalLoad} />
                <div className="total-load-text">
                  {productData?.totalWatts}W, {productData?.batteryPower}Ah
                  <span>{staticContent.totalLoad}</span>
                </div>
              </motion.div>
              <motion.div
                className="device-image"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
              >
                <motion.img src={Devices} variants={scaleFromRightCorner} />
              </motion.div>
              <motion.div
                className="vguardHoriz"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
              >
                <motion.img src={VguardHoriz} variants={scaleFromRightCorner} />
              </motion.div>
            </motion.div>
            <motion.div
              className="vguardVertical"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <motion.img src={VguardVertical} variants={fromBottom} />
            </motion.div>
          </div>
        </div>
      </div>
      <div className="container">
        {warningMessage && (
          <div className="maxLoadWarningMessage">
            <img src={WarningIcon} alt="warningIcon" /> {warningMessage}
          </div>
        )}
      </div>

      {/* top choices */}
      <div className="container">
        <div
          className={
            bestCombo ? `best-combo-container` : `productTopListingSection`
          }
        >
          {bestCombo && (
            <motion.div
              className="best-combo-choice"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={fromBottom}
            >
              <div className="best-combo-head">
                {staticContent.bestComboForYou}
              </div>
              <div className="best-combo">
                <ProductCard
                  style={{ cursor: "pointer" }}
                  product={topChoice?.comboInverter}
                  disable={endPoint == "com" ? true : false}
                  clickOnBuy={() =>
                    window.open(topChoice.comboInverter.url, "_blank")
                  }
                  onClick={() =>
                    window.open(topChoice.comboInverter.url, "_blank")
                  }
                  match={false}
                />
              </div>
            </motion.div>
          )}
          <motion.div
            className={bestCombo ? `best-top-choice` : `top-choice`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fromBottom}
          >
            <div className="top-head"> {staticContent.topChoices}</div>

            <div
              className={
                bestCombo ? `best-top-choice-cards` : `top-choice-cards`
              }
            >
              <>
                {/* inverter */}
                <motion.div
                  variants={cardVariants}
                  onClick={() => window.open(topChoice.inverter?.url, "_blank")}
                >
                  <div className="sub-title">
                    {staticContent.totalCapcity}{" "}
                    <span>
                      {productData?.totalWatts}W, {productData?.batteryPower}Ah
                    </span>
                  </div>
                  <Card
                    className={
                      bestCombo
                        ? `best-top-product-card-main`
                        : `top-product-card-main`
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="product-image">
                      <img src={topChoice.inverter?.image} alt="Product" />
                    </div>
                    <Card.Body>
                      <div className="product-name">
                        {topChoice.inverter?.name}
                      </div>
                      <div
                        className={
                          bestCombo
                            ? "best-combo-wrapper"
                            : "top-choice-wrapper"
                        }
                      >
                        <div
                          className={
                            bestCombo
                              ? `best-combo-body-top-choice`
                              : `body-top-choice`
                          }
                        >
                          <div>
                            <img src={Capacity} alt="Capacity" />
                            {topChoice.inverter?.capacity}{" "}
                            {staticContent.findDealer.VACapacity}
                          </div>
                          <div>
                            <img src={wave} alt="sine wave" />
                            {capitalizeWords(topChoice?.inverter?.type)}
                          </div>
                          <div
                            className={`${
                              topChoice.inverter?.mobileConnectivity === true
                                ? "active-choice"
                                : "inactive-choice"
                            }`}
                          >
                            <div
                              className={`${
                                topChoice.inverter?.mobileConnectivity == true
                                  ? "active-choice-img"
                                  : "inactive-choice-img"
                              }`}
                            >
                              <Connectivity />
                            </div>
                            {capitalizeWords(
                              staticContent.findDealer.connecitivity
                            )}
                          </div>
                          <div
                            className={`${
                              topChoice.inverter?.solarModel == true
                                ? "active-choice"
                                : "inactive-choice"
                            }`}
                          >
                            <div
                              className={`${
                                topChoice.inverter?.solarModel == true
                                  ? "active-choice-img"
                                  : "inactive-choice-img"
                              }`}
                            >
                              <Solar />
                            </div>
                            {capitalizeWords(staticContent.findDealer.Solar)}
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          bestCombo ? "best-choice-button" : "buttonProduct"
                        }
                      >
                        {/* {endPoint == "com" && ( */}
                        <ButtonComponent
                          buttonText={
                            endPoint === "com"
                              ? staticContent.buttonCom
                              : staticContent.buttonIn
                          }
                          onClick={() =>
                            window.open(topChoice.inverter?.url, "_blank")
                          }
                        />
                        {/* )} */}
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
                <div className="add-icon">
                  {/* Plus Icon between Cards */}

                  <div
                    style={{
                      color: "rgba(255, 255, 255, 0.5)",
                    }}
                  >
                    <PlusIcon size={bestCombo ? 30 : 50} />
                  </div>
                </div>

                <motion.div
                  variants={cardVariants}
                  onClick={() => window.open(topChoice.battery?.url, "_blank")}
                >
                  <div className="sub-title">
                    <span>
                      {productData?.recommendedDevices.batteries.count} 
                      {staticContent.batteryRequired}
                    </span>
                  </div>
                  <Card
                    className={
                      bestCombo
                        ? `best-top-product-card-main specific-card`
                        : `top-product-card-main`
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div className="product-image">
                      <img src={topChoice.battery?.image} alt="Product" />
                    </div>
                    <Card.Body className="alignCenter">
                      <div className="product-name">
                        {topChoice.battery?.name}
                      </div>
                      <div
                        className={
                          bestCombo
                            ? "best-combo-wrapper"
                            : "top-choice-wrapper"
                        }
                      >
                        <div className="body-battery-choice">
                          <div
                            className={
                              bestCombo ? "best-combo-img" : "singleDataImg"
                            }
                          >
                            <img src={Capacity} alt="Capacity" />
                            {topChoice.battery?.capacity}{" "}
                            {staticContent.findDealer.AhCapacity}
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          bestCombo
                            ? "best-choice-battery-button"
                            : "buttonProduct"
                        }
                      >
                        <ButtonComponent
                          buttonText={
                            endPoint === "com"
                              ? staticContent.buttonCom
                              : staticContent.buttonIn
                          }
                          onClick={() =>
                            window.open(topChoice.battery?.url, "_blank")
                          }
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </>
            </div>
          </motion.div>
        </div>
      </div>

      {/* best combo section */}
      {bestCombo && (
        <div className="scroll-inverter-section">
          <div className="container">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={fromBottom}
              className="inverter"
            >
              <div className="heading-section">
                <div>{staticContent.comboForYou}</div>
              </div>
              <div className="product-page-container ">
                {productData?.recommendedDevices?.comboInverters?.map(
                  (item, index) => (
                    <motion.div
                      key={item.id}
                      className="products-list"
                      variants={cardVariants}
                      custom={index}
                    >
                      <ProductCard
                        style={{ cursor: "pointer" }}
                        product={item}
                        disable={endPoint == "com" ? true : false}
                        clickOnBuy={() => window.open(item.url, "_blank")}
                        onClick={() => window.open(item.url, "_blank")}
                      />
                    </motion.div>
                  )
                )}
              </div>
            </motion.div>
          </div>
        </div>
      )}

      {/* inverters  */}
      <div className="scroll-inverter-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fromBottom}
            className="inverter"
          >
            <div className="heading-section">
              <div>{staticContent.inverters}</div>
            </div>
            <div className="product-page-container ">
              {productData?.recommendedDevices?.inverters?.map(
                (item, index) => (
                  <motion.div
                    key={item.id}
                    className="products-list"
                    variants={cardVariants}
                    custom={index}
                  >
                    <ProductCard
                      style={{ cursor: "pointer" }}
                      product={item}
                      disable={endPoint == "com" ? true : false}
                      clickOnBuy={() => window.open(item.url, "_blank")}
                      onClick={() => window.open(item.url, "_blank")}
                    />
                  </motion.div>
                )
              )}
            </div>
          </motion.div>
          {endPoint == "in" && ( //IN
            <div className="connect-to-dealer ">
              <ButtonComponent
                buttonText={"Enquire Now"}
                type="yellowOutlined"
                variant="rounded"
                onClick={() => setShowEnquireModal(true)}
              />
              <ButtonComponent
                buttonText={staticContent.connectADealer}
                type="filled"
                variant="rounded"
                onClick={() => setShowModal(true)}
              />
            </div>
          )}
        </div>
      </div>
      <FindDealer
        show={showModal}
        setShow={setShowModal}
        title="Find a Dealer"
        onChange={handleInputChange}
        onSearch={handleSearch}
        handleClose={handleCloseModal}
      >
        {showDealerData && (
          <>
            <div className="dealer-count">
              {!isLoading ? (
                popupMessage ? (
                  <div>{popupMessage}</div>
                ) : dealerData.length > 0 ? (
                  <div>Found {dealerData.length} Dealers</div>
                ) : (
                  <div>{staticContent.findDealer.noDealer}</div>
                )
              ) : (
                <Loader />
              )}
            </div>
            <div className="dealer-data">
              {dealerData.map((item) => (
                <>
                  <div className="dealer-details">
                    <div className="dealer-name">{item.customerName}</div>
                    <div>
                      <div className="label">
                        {staticContent.findDealer.dealerAddress}
                      </div>
                      {item.city}, {item.district}, {item.region},
                      {item.postalCode}
                    </div>

                    <div>
                      <div className="label">
                        {staticContent.findDealer.phoneNumber}
                      </div>
                      {item.mobile ? item.mobile : "-"}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </>
        )}
      </FindDealer>
      <EnterDetailsPopup
        show={showEnquireModal}
        setShow={setShowEnquireModal}
        onClick={() => {
          ConnectDealer(userDetailsToSend);
        }}
        popupUserDetails={popupUserDetails}
      />
      <SuccessPopup
        show={successPopup}
        setShow={setSuccessPopup}
        onSubmit={() => {
          setSuccessPopup(false);
        }}
        image={SuccessImage}
        title={staticContent.success}
        description={popupMessage}
        buttonText={staticContent.close}
        isClose={false}
      />
      <ErrorPopup
        show={errorPopup}
        setShow={setErrorPopup}
        onSubmit={() => {
          setErrorPopup(false);
          ConnectDealer(userDetailsToSend);
        }}
        image={ErrorImage}
        title={staticContent.error}
        description={popupMessage}
        buttonText={staticContent.retry}
      />
    </div>
  );
};

export default ProductPage;
